export const PORTFOLIO_BASE = "/portfolio";

// separate out routing in case portfolio routing is split later
export const PORTFOLIO_OVERVIEW_SLUG = PORTFOLIO_BASE;

export const LOAN_SLUG = "/loan";

export const MARKET_SLUG = "/market";
export const BORROW_SLUG = "/borrow";
export const EARN_SLUG = "/earn";
export const LEND_SLUG = "/lend";
export const LOOPS_SLUG = "/loops";
export const MARKETS_SLUG = "/markets";
export const LOOP_DETAIL_SLUG = LOOPS_SLUG;
export const VAULT_MANAGER_SLUG = "/manager";
export const LEND_VAULT_DETAIL_SLUG = "/vault";
export const STRATEGY_LOANS_SLUG = "/position/loans";

export const SIGNUP_SLUG = "/signup";

const ACCOUNTS_BASE = "/account";
export const ACCOUNT_SETTINGS_SLUG = ACCOUNTS_BASE;
export const PRIME_SLUG = `${ACCOUNT_SETTINGS_SLUG}?open=prime`;

export const POINTS_SLUG = "/points";
export const WAITLIST_SLUG = POINTS_SLUG;

export const TWITTER_SLUG = "/twitter";

export const DISCORD_SLUG = "/discord";
export const ECOSYSTEM_SLUG = "/ecosystem";

export const LOCKBOX_SLUG = "/lockbox";
export const LOCKBOX_DETAIL_SLUG = "/lockbox";
